<template>
  <div>
    <button
        :disabled="botaoDesativado"
        @click="abrirDialogoConfirmacaoSolicitarAssinatura"
    >
      {{ textoBotao }}
    </button>

    <mensagem-confirmacao
        :exibirMensagem="mostrarDialogoConfirmacaoSolicitarAssinatura"
        :titulo="textoBotao"
        :textoSecundario="`Deseja realmente ${textoBotao.toLowerCase()}?`"
        @confirmado="confirmar"
        @recusado="fecharDialogoConfirmacaoSolicitarAssinatura"/>
  </div>
</template>

<script>
export default {
    name: 'BotaoSolicitarAssinatura',
    props: {
        statusAssinatura: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            mostrarDialogoConfirmacaoSolicitarAssinatura: false
        }
    },
    computed: {
        textoBotao() {
            switch (this.statusAssinatura) {
            case 'EXPIRADO':
                return 'Renovar Solicitação de Assinatura'
            case 'ENVIADO':
                return 'Assinatura Solicitada'
            default:
                return 'Solicitar Assinatura'
            }
        },
        botaoDesativado() {
            return this.statusAssinatura === 'ENVIADO'
        }
    },
    methods: {
        abrirDialogoConfirmacaoSolicitarAssinatura() {
            if (!this.botaoDesativado) {
                this.mostrarDialogoConfirmacaoSolicitarAssinatura = true
            }
        },
        fecharDialogoConfirmacaoSolicitarAssinatura() {
            this.mostrarDialogoConfirmacaoSolicitarAssinatura = false
        },
        confirmar() {
            this.fecharDialogoConfirmacaoSolicitarAssinatura()
            this.$emit('confirmarSolicitacao')
        }
    }
}
</script>